import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { PlotFilterType } from '../components/PageConfigProvider/types/item';
import { FilterId } from '../filters/types/filters';

const items: TabContent['items'] = [
  {
    id: 'bf6ce57d-8211-4ac9-9c10-09bc6bf6cb93',
    title: 'Description',
    info: {
      text: 'Descriptions are sourced from online entity profile pages or AI generated text.',
    },
    position: { x: 0, y: 0, width: 24, height: 18 },
    plot: {
      chartType: 'entity-summary',
      defaultMetricOptions: ['entity_summary'],
    },
  },
  {
    id: '7631a6b8-a948-4053-9dd0-83dbaf3e46d6',
    title: 'Sentiment',
    position: { x: 32, y: 18, width: 16, height: 18 },
    plot: {
      chartType: 'diverging-bar',
      plotFilters: [
        { type: PlotFilterType.TOP_N, value: 5 },
        { type: PlotFilterType.BOTTOM_N, value: 5 },
      ],
      defaultMetricOptions: ['sentiment_top_bottom'],
      divergingBar: {
        negativeLabel: '',
        positiveLabel: '',
      },
    },
  },
  {
    id: '8206edd2-5700-4b8a-b552-09d69690d89a',
    title: 'Headcount',
    position: { x: 0, y: 18, width: 16, height: 9 },
    plot: { chartType: 'line', defaultMetricOptions: ['headcount'] },
  },
  {
    id: '0fd73c3a-0d2e-426c-94dc-7c9f37a18e88',
    title: null,
    position: { x: 24, y: 0, width: 24, height: 18 },
    plot: { chartType: 'map', defaultMetricOptions: ['headcount'] },
  },
  {
    id: 'company-overview-salary-distribution',
    title: 'Pay',
    info: {
      text: 'The distribution of total compensation. More information on the compensation model can be found <a>.',
      hyperlinks: [
        {
          text: 'here',
          href: 'https://www.data-dictionary.reveliolabs.com/methodology.html#salary',
        },
      ],
    },
    position: { x: 16, y: 18, width: 16, height: 18 },
    plot: {
      chartType: 'box',
      secondaryDimension: 'geography',
      groupBySegment: false,
      plotFilters: [{ type: PlotFilterType.TOP_N, value: 5 }],
      defaultMetricOptions: ['total_compensation'],
    },
  },
  {
    id: 'ebdf57f4-2c27-4cc6-ab27-3a5e70a7b8c7',
    title: 'Postings',
    position: { x: 0, y: 27, width: 16, height: 9 },
    plot: { chartType: 'line', defaultMetricOptions: ['postings_active'] },
  },
];

const companyOverviewTab: TabContent = {
  id: 'company-overview',
  items,
  primaryFilter: {
    id: FilterId.COMPANY,
    selectionLimit: 1,
    selectionDefault: 1,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.ROLE,
    FilterId.GEOGRAPHY,
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.CONTINGENT_WORKERS,
    FilterId.EDUCATION,
    FilterId.ETHNICITY,
    FilterId.GENDER,
    FilterId.TITLE,
    FilterId.KEYWORDS,
  ].map((id) => ({ id })),
  dateRangeDefault: 'posting-provider-range',
};

export const companyOverview: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_OVERVIEW_V2,
  revelioPageId: RevelioPageId.COMPANY_OVERVIEW_V2,
  name: 'Overview',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-overview',
      label: 'Overview',
      tabContent: companyOverviewTab,
      isActive: true,
    },
  ],
};
